/* eslint @typescript-eslint/naming-convention: 0 */
import type { ExperienceSortType } from '@/wabunka-src/common/features/Experience/utils/experienceListSort';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface ChangeSortParams {
  sort_type: ExperienceSortType;
}

/**
 * 発火タイミング：一覧のソート切替 UI で並び順を選んだ際。
 * ※ 切替は URL のパスが変わらないため page_view では見分けられず、専用イベントで取る。
 */
export const sendGAWabunkaChangeSortEvent = (sortType: ExperienceSortType) => {
  sendWabunkaGAEvent('change_sort', { sort_type: sortType });
};
